export const AGENCY_CLAIMS = 'AGENCY_CLAIMS';
export const CARRIER_CLAIMS = 'CARRIER_CLAIMS';
export const CLAIMS_DIARY = 'CLAIMS_DIARY';
export const CLAIMS_EXPERTS = 'CLAIMS_EXPERTS';
export const CLAIMS_INCURRED_AGGS = 'CLAIMS_INCURRED_AGGS';
export const CLAIMS_INVOICES = 'CLAIMS_INVOICES';
export const CLAIMS_INVOICES_AGGS = 'CLAIMS_INVOICES_AGGS';
export const CLAIMS_STATUS_AGGS = 'CLAIMS_STATUS_AGGS';
export const CLAIMS_AGGREGATE_RESERVES = 'CLAIMS_AGGREGATE_RESERVES';
export const CLAIMS_TASKS = 'CLAIMS_TASKS';
/** React Query key prefixes for a claim's task list and its coverage-letter position. */
export const CLAIM_TASKS_QUERY_KEY = 'claim-tasks';
export const CLAIM_COVERAGE_LETTER_QUERY_KEY = 'claim-coverage-letter';
export const COWBELL_CLAIMS = 'COWBELL_CLAIMS';
export const COWBELL_CLAIMS_INVOICES = 'COWBELL_CLAIMS_INVOICES';
export const COWBELL_LOSS_RATIO_GRAPH = 'COWBELL_LOSS_RATIO_GRAPH';
export const RESERVE_DATA_AGGS = 'RESERVE_DATA_AGGS';
export const VENDOR_CLAIMS = 'VENDOR_CLAIMS';

/**
 * The start of a claims search's date window that reaches every claim, in unix seconds
 * (2000-01-01). With no `after` the claims service keeps only claims modified in the last year.
 */
export const ALL_CLAIMS_AFTER = 946_684_800;

/**
 * Width, in px, of the invoice listings' Action column.
 *
 * <p>Pixels because the dev-express column API is numeric-px by contract: `calculateColumnWidth`
 * accepts a number, a percentage, `auto` or one of its own size tokens, and throws on anything
 * else -- a rem string cannot be passed here.
 *
 * <p>Set at all, because a column with no width falls to the 180px default and, on a fill-enabled
 * table (`CLAIMS_INVOICES`), is also treated as flexible and absorbs the leftover width -- 750px
 * on a 1600px table, 1230px at 2560. Its neighbours are pinned icon columns, so that slack opened
 * a gap between them, widest on the rows where the cell renders nothing at all.
 *
 * <p>The number is measured, not derived. The cell holds two icon controls -- the billing
 * conversation and the actions menu -- which come to 58.5px including the gap between them, and
 * the cell's own horizontal padding of 1.25rem a side sits inside this width. 90 leaves each of
 * them the same 1.25rem the select column gives its checkbox, which is what makes the pinned
 * columns read as one block rather than as content floating in its own lane.
 *
 * <p>It was 132 while this column held a labelled button -- "Approve" at 108.9px on a 16px root.
 * The buttons became one icon menu and then gained the conversation beside them; the width kept
 * the old figure, and the 40px it no longer needed showed up as a gap on every row.
 */
export const INVOICE_ACTION_COLUMN_WIDTH = 90;
